import {useTheme} from "@emotion/react";
import defaultImage from "@/assets/images/b10img.svg";
import defaultPictogramme from "@/assets/images/b10pictogramme.svg";
import {B10Ad, BASE_AD_TAG} from "@/components/adSections/index";
import type {SectionPushVm} from "@/generated/api";
import {useAdSlotEmpty} from "@/hooks/useAdSlotEmpty";
import SectionWrapper from "@/layouts/SectionWrapper";
import {theme} from "@/styles/theme";
import PushMailCta from "../B10PushMail/PushMailCta";
import {
  ContentWrapper,
  PushMailImage,
  PushMailPictogramme,
  PushMailText,
  PushMailTitle,
  PushMailWrapper,
  TitleWrapper,
} from "./styles";

interface B10PushMailVMProps {
  sectionData: SectionPushVm;
  b10AdTag?: number;
  isFirstSection?: boolean;
  isLastSection?: boolean;
  ad_enabled?: boolean;
  id?: string;
}

// The "Bloc - Push VM" fields (acf-json) are the title, the text, the call to action and the background: unlike B10PushMail it has no image
// and no pictogram, so its image and its pictogram are always the default ones (it used to read `image`, `title_picto` and
// `image_mobile_position` of the data, which are never there: 906 sections checked)
const B10PushMail = ({
  sectionData,
  b10AdTag,
  isFirstSection,
  isLastSection,
  ad_enabled,
  id,
}: B10PushMailVMProps) => {
  const {title, text, cta_title, cta_target, cta_url, bg_color} = sectionData;
  const {breakpoints} = useTheme();
  const {md} = breakpoints;
  const showAd = ad_enabled && !md;
  // biome-ignore lint/suspicious/noExplicitAny: b10AdTag===2 renvoie déjà un tableau au lieu d'une clé BASE_AD_TAG (incohérence préexistante hors scope de cette tâche) ; ne pas changer le comportement runtime
  const tag: any =
    b10AdTag === 1 ? BASE_AD_TAG["300*250"] : b10AdTag === 2 ? ["2*300*250"] : null;
  const {ref: b10AdRef, isEmpty: isAdEmpty} = useAdSlotEmpty(!!(showAd && !!tag));
  const adVisible = showAd && !isAdEmpty;

  return (
    <SectionWrapper
      id={id}
      backgroundColor={bg_color}
      isFirstSection={isFirstSection}
      isLastSection={isLastSection}
    >
      <PushMailWrapper showAd={adVisible} aria-label="background image">
        <PushMailImage
          showAd={adVisible}
          src={defaultImage}
          alt="michelin brand image"
          title="michelin brand image"
          loading="lazy"
        />
        <ContentWrapper>
          <TitleWrapper>
            <PushMailPictogramme src={defaultPictogramme} alt="picto" loading="lazy" />
            <PushMailTitle>{title}</PushMailTitle>
          </TitleWrapper>
          <PushMailText>{text}</PushMailText>
          <PushMailCta
            title={cta_title}
            url={cta_url}
            target={cta_target?.[0]}
            buttonColor={theme?.colors?.brandLightBlue}
          />
        </ContentWrapper>
      </PushMailWrapper>
      {showAd && tag && !isAdEmpty && <B10Ad ref={b10AdRef} tag={tag} />}
    </SectionWrapper>
  );
};

export default B10PushMail;
